const regex = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/g;

const emailAddressValidation = (address) => {
  if (address !== null) {
    if (!address.match(regex)) {
      return false;
    }
  }
  return true;
};

export default emailAddressValidation;
